module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-content-wrapper"
  }, [_c('div', {
    staticClass: "container-fluid container-fixed-lg"
  }, [_c('div', {
    staticClass: "panel panel-transparent"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('page-title', {
    attrs: {
      "title": _vm.$t('administracao.perfilAcesso.titulos.perfisAcesso'),
      "subTitle": _vm.pageTitleSubTitle
    }
  }), _c('filter-portlet', {
    attrs: {
      "portletTitle": _vm.filterPortletTitle
    }
  }, [_c('form', {
    attrs: {
      "slot": "filters"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.newProfile.apply(null, arguments)
      }
    },
    slot: "filters"
  }, [(!_vm.isMasterProfile(_vm.profileToEditId)) ? _c('step-progress', {
    attrs: {
      "steps": _vm.steps,
      "current-step": _vm.currentStep
    }
  }) : _vm._e(), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currentStep === 0),
      expression: "currentStep === 0"
    }]
  }, [_c('div', {
    staticClass: "row row-filter-small"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "profileName"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('administracao.perfilAcesso.labels.perfilInfo'))
    }
  }), _c('label', {
    staticClass: "control-label required-label"
  }, [_vm._v("*")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profile.name),
      expression: "profile.name"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        rules: {
          required: true
        }
      }),
      expression: "{ rules: { required: true } }"
    }],
    staticClass: "form-control",
    class: {
      'input': true,
      'is-danger': _vm.errors.has('profileName')
    },
    attrs: {
      "type": "text",
      "id": "profileName",
      "name": "profileName",
      "maxlength": "40",
      "readonly": _vm.isMasterProfile(_vm.profileToEditId)
    },
    domProps: {
      "value": (_vm.profile.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.profile, "name", $event.target.value)
      }
    }
  }), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('profileName')),
      expression: "errors.has('profileName')"
    }],
    staticClass: "help is-danger",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('validacao.campoObrigatorio'))
    }
  })])]), _c('div', {
    staticClass: "row row-filter-small"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('label', {
    staticClass: "control-label",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('administracao.perfilAcesso.labels.visibilidade'))
    }
  }), _c('label', {
    staticClass: "control-label required-label"
  }, [_vm._v("*")]), _c('div', {
    staticClass: "radio radio-success mt-0"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profile.visibility),
      expression: "profile.visibility"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "type": "radio",
      "id": "visibilityAll",
      "name": "visibility",
      "value": "0"
    },
    domProps: {
      "checked": _vm._q(_vm.profile.visibility, "0")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.profile, "visibility", "0")
      }
    }
  }), _c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "visibilityAll"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('administracao.perfilAcesso.labels.visibilidadeAcessaTodos'))
    }
  }), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profile.visibility),
      expression: "profile.visibility"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "type": "radio",
      "id": "visibilitySome",
      "name": "visibility",
      "value": "1"
    },
    domProps: {
      "checked": _vm._q(_vm.profile.visibility, "1")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.profile, "visibility", "1")
      }
    }
  }), _c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "visibilitySome"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('administracao.perfilAcesso.labels.visibilidadeAcessaAlguns'))
    }
  })]), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('visibility')),
      expression: "errors.has('visibility')"
    }],
    staticClass: "help is-danger",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('validacao.campoObrigatorio'))
    }
  })])]), _c('div', {
    staticClass: "row row-filter-small"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('label', {
    staticClass: "control-label",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('administracao.perfilAcesso.labels.funcionalidades'))
    }
  }), _c('label', {
    staticClass: "control-label required-label"
  }, [_vm._v("*")]), _c('div', {
    staticClass: "boxed-container"
  }, [_c('div', {
    staticClass: "px-0 checkbox check-success"
  }, [_c('input', {
    attrs: {
      "type": "checkbox",
      "id": "selectAllFunctionalities",
      "name": "selectAllFunctionalities",
      "disabled": _vm.isMasterProfile(_vm.profileToEditId)
    },
    domProps: {
      "checked": _vm.allFunctionalitiesSelected
    },
    on: {
      "click": function($event) {
        return _vm.selectAllFunctionalities()
      }
    }
  }), _c('label', {
    staticClass: "func-group-labels",
    attrs: {
      "for": "selectAllFunctionalities"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('administracao.perfilAcesso.labels.selecionarTodos'))
    }
  })]), _c('div', {
    staticClass: "row row-filter-small"
  }, _vm._l((_vm.functionalitiesGroups), function(functionalityGroup, index) {
    return _c('div', [(functionalityGroup.funcionalidades && functionalityGroup.funcionalidades.length > 0) ? _c('div', [_c('div', {
      staticClass: "group-checkbox checkbox check-success"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (functionalityGroup.checked),
        expression: "functionalityGroup.checked"
      }],
      attrs: {
        "type": "checkbox",
        "id": functionalityGroup.id,
        "name": "functionalityGroup",
        "disabled": _vm.isMasterProfile(_vm.profileToEditId)
      },
      domProps: {
        "checked": Array.isArray(functionalityGroup.checked) ? _vm._i(functionalityGroup.checked, null) > -1 : (functionalityGroup.checked)
      },
      on: {
        "change": [function($event) {
          var $$a = functionalityGroup.checked,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(functionalityGroup, "checked", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(functionalityGroup, "checked", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(functionalityGroup, "checked", $$c)
          }
        }, function($event) {
          return _vm.selectFunctionalityGroup(functionalityGroup)
        }]
      }
    }), _c('label', {
      staticClass: "func-group-title",
      attrs: {
        "for": functionalityGroup.id
      },
      on: {
        "click": function($event) {
          return _vm.trackEventOnFunctionalityGroup(functionalityGroup.nome)
        }
      }
    }, [_c('i', {
      class: _vm.getGroupIcon(functionalityGroup.id)
    }), _c('span', {
      staticClass: "func-group-title-label"
    }, [_vm._v(_vm._s(functionalityGroup.nome))]), (functionalityGroup.id == 35) ? _c('i', {
      staticClass: "fa fa-info-circle info-icon",
      attrs: {
        "title": _vm.$t('administracao.perfilAcesso.labels.hintEmularAcesso')
      }
    }) : _vm._e()])]), _c('div', {
      staticClass: "col-xs-10 check-group bottom-bordered"
    }), _c('div', {
      staticClass: "col-xs-10"
    }, _vm._l((functionalityGroup.funcionalidades), function(functionality, idx) {
      return _c('div', {
        staticClass: "check-group func-padded"
      }, [_c('div', {
        staticClass: "checkbox check-success",
        class: _vm.getCheckFuncContainerClass(idx)
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (functionality.checked),
          expression: "functionality.checked"
        }, {
          name: "validate",
          rawName: "v-validate",
          value: ('required'),
          expression: "'required'"
        }],
        attrs: {
          "type": "checkbox",
          "id": functionality.id,
          "name": "functionality",
          "disabled": _vm.isMasterProfile(_vm.profileToEditId)
        },
        domProps: {
          "checked": Array.isArray(functionality.checked) ? _vm._i(functionality.checked, null) > -1 : (functionality.checked)
        },
        on: {
          "change": [function($event) {
            var $$a = functionality.checked,
              $$el = $event.target,
              $$c = $$el.checked ? (true) : (false);
            if (Array.isArray($$a)) {
              var $$v = null,
                $$i = _vm._i($$a, $$v);
              if ($$el.checked) {
                $$i < 0 && (_vm.$set(functionality, "checked", $$a.concat([$$v])))
              } else {
                $$i > -1 && (_vm.$set(functionality, "checked", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
              }
            } else {
              _vm.$set(functionality, "checked", $$c)
            }
          }, function($event) {
            return _vm.selectFunctionality(functionality)
          }]
        }
      }), _c('label', {
        staticClass: "func-group-labels",
        attrs: {
          "for": functionality.id
        },
        on: {
          "click": function($event) {
            return _vm.trackEventOnFunctionality(functionality.nome)
          }
        }
      }, [_vm._v(_vm._s(functionality.nome))])])])
    }), 0), _c('br'), _c('br')]) : _vm._e()])
  }), 0)]), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('functionality')),
      expression: "errors.has('functionality')"
    }],
    staticClass: "help is-danger",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('validacao.campoObrigatorio'))
    }
  })])])]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currentStep === 1),
      expression: "currentStep === 1"
    }]
  }, [_c('div', {
    attrs: {
      "id": "establishments"
    }
  }, [_c('v-client-table', {
    ref: "table",
    staticClass: "data-table custom-data-table",
    attrs: {
      "data": _vm.establishments.establishments,
      "columns": _vm.establishments.columns,
      "options": _vm.establishments.options
    },
    scopedSlots: _vm._u([{
      key: "check",
      fn: function(props) {
        return [_c('div', {
          staticClass: "checkbox check-success pl-0 checkbox-table-input checkbox-table-input-row"
        }, [_c('input', {
          attrs: {
            "type": "checkbox",
            "id": ("check-establishment-" + (props.row["id"])),
            "name": "checkEstablishment",
            "disabled": _vm.isMasterProfile(_vm.profileToEditId)
          },
          domProps: {
            "checked": props.row.checked
          },
          on: {
            "click": function($event) {
              return _vm.selectEstablishment(props.row)
            }
          }
        }), _c('label', {
          staticClass: "func-group-labels",
          attrs: {
            "for": ("check-establishment-" + (props.row["id"]))
          }
        })])]
      }
    }])
  }, [_c('template', {
    slot: "h__check"
  }, [_c('div', {
    staticClass: "checkbox check-success pl-0 checkbox-table-input checkbox-table-input-header"
  }, [_c('input', {
    attrs: {
      "type": "checkbox",
      "id": "allEstablishmentsSelected",
      "name": "allEstablishmentsSelected",
      "disabled": _vm.isMasterProfile(_vm.profileToEditId)
    },
    domProps: {
      "checked": _vm.establishments.allEstablishmentsSelected
    },
    on: {
      "click": function($event) {
        return _vm.selectAllEstablishments()
      }
    }
  }), _c('label', {
    staticClass: "func-group-labels",
    attrs: {
      "for": "allEstablishmentsSelected"
    }
  })])])], 2)], 1)]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currentStep === 2),
      expression: "currentStep === 2"
    }]
  }, [_c('div', {
    attrs: {
      "id": "accounts"
    }
  }, [_c('v-client-table', {
    ref: "table",
    staticClass: "data-table custom-data-table",
    attrs: {
      "data": _vm.bankAccounts.accounts,
      "columns": _vm.bankAccounts.columns,
      "options": _vm.bankAccounts.options
    },
    scopedSlots: _vm._u([{
      key: "check",
      fn: function(props) {
        return [_c('div', {
          staticClass: "checkbox check-success pl-0 checkbox-table-input checkbox-table-input-row"
        }, [_c('input', {
          attrs: {
            "type": "checkbox",
            "id": ("check-bankAccount-" + (props.row["id"])),
            "name": "checkBankAccount",
            "disabled": _vm.isMasterProfile(_vm.profileToEditId)
          },
          domProps: {
            "checked": props.row.checked
          },
          on: {
            "click": function($event) {
              return _vm.selectBankAccount(props.row)
            }
          }
        }), _c('label', {
          staticClass: "func-group-labels",
          attrs: {
            "for": ("check-bankAccount-" + (props.row["id"]))
          }
        })])]
      }
    }])
  }, [_c('template', {
    slot: "h__check"
  }, [_c('div', {
    staticClass: "checkbox check-success pl-0 checkbox-table-input checkbox-table-input-header"
  }, [_c('input', {
    attrs: {
      "type": "checkbox",
      "id": "allBankAccountsSelected",
      "name": "allBankAccountsSelected",
      "disabled": _vm.isMasterProfile(_vm.profileToEditId)
    },
    domProps: {
      "checked": _vm.bankAccounts.allBankAccountsSelected
    },
    on: {
      "click": function($event) {
        return _vm.selectAllBankAccounts()
      }
    }
  }), _c('label', {
    staticClass: "func-group-labels",
    attrs: {
      "for": "allBankAccountsSelected"
    }
  })])]), _c('template', {
    slot: "filter__banco"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    on: {
      "input": function($event) {
        return _vm.handleFilter($event, 'banco')
      }
    }
  })]), _c('template', {
    slot: "filter__agencia"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    on: {
      "input": function($event) {
        return _vm.handleFilter($event, 'agencia')
      }
    }
  })]), _c('template', {
    slot: "filter__conta"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    on: {
      "input": function($event) {
        return _vm.handleFilter($event, 'conta')
      }
    }
  })])], 2)], 1)]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currentStep === 3),
      expression: "currentStep === 3"
    }]
  }, [_c('div', {
    attrs: {
      "id": "confirmation"
    }
  }, [_c('div', {
    staticClass: "row row-filter-small p-5 bg-gray"
  }, [_c('div', {
    staticClass: "col-xs-6"
  }, [_c('p', {
    staticClass: "mb-0"
  }, [_c('strong', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('administracao.perfilAcesso.labels.perfilInfo'))
    }
  })])]), _c('div', {
    staticClass: "col-xs-6 pl-0"
  }, [_c('p', {
    staticClass: "mb-0"
  }, [_c('strong', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('administracao.perfilAcesso.labels.visibilidade'))
    }
  })])])]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-6 row-filter-small"
  }, [_c('p', {
    staticClass: "mb-0"
  }, [_vm._v(_vm._s(_vm.profile.name))])]), _c('div', {
    staticClass: "col-xs-6 row-filter-small pl-0"
  }, [_c('p', {
    staticClass: "mb-0"
  }, [_vm._v(_vm._s(_vm.profile.visibility === '0' ? _vm.$t('administracao.perfilAcesso.labels.visibilidadeAcessaTodos') : _vm.$t('administracao.perfilAcesso.labels.visibilidadeAcessaAlguns')))])])]), _c('div', {
    staticClass: "row row-filter-small p-5 bg-gray"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('p', {
    staticClass: "mb-0"
  }, [_c('strong', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('administracao.perfilAcesso.labels.funcionalidades'))
    }
  })])])]), _c('div', {
    staticClass: "row row-filter-small d-flex flex-wrap"
  }, _vm._l((_vm.functionalitiesGroups), function(functionalityGroup, index) {
    return _c('div', {
      staticClass: "col-xs-4 row-filter-small pl-0"
    }, [(functionalityGroup.funcionalidades && functionalityGroup.funcionalidades.length > 0) ? _c('div', [_c('p', {
      staticClass: "func-group-title mb-5"
    }, [_c('i', {
      class: _vm.getGroupIcon(functionalityGroup.id)
    }), _c('span', {
      staticClass: "func-group-title-label"
    }, [_vm._v(_vm._s(functionalityGroup.nome) + ":")])]), _vm._l((_vm.profile.functionalitiesSelected), function(functionality) {
      return _c('div', [(functionalityGroup.id === functionality.grupoFuncionalidade.id) ? _c('p', {
        staticClass: "mb-0"
      }, [_vm._v(_vm._s(functionality.nome))]) : _vm._e()])
    })], 2) : _vm._e()])
  }), 0), _c('div', {
    staticClass: "row row-filter-small p-5 bg-gray"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('p', {
    staticClass: "mb-0"
  }, [_c('strong', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('administracao.perfilAcesso.etapas.estabelecimentos'))
    }
  })])])]), (_vm.profile.establishmentsSelected.length > 0) ? _c('div', {
    staticClass: "row"
  }, _vm._l((_vm.profile.establishmentsSelected), function(establishment) {
    return _c('div', {
      staticClass: "col-xs-6 row-filter-small pl-0"
    }, [_c('p', {
      staticClass: "mb-0"
    }, [_vm._v(_vm._s(_vm.$t('estabelecimentos.labels.nome')) + " (" + _vm._s(_vm.$t('estabelecimentos.labels.nomeFantasia')) + "): " + _vm._s(establishment.nome) + " (" + _vm._s(establishment.nomeFantasia) + ")")]), _c('p', {
      staticClass: "mb-0"
    }, [_vm._v(_vm._s(_vm.$t('estabelecimentos.labels.cnpj')) + ": " + _vm._s(establishment.cnpj))])])
  }), 0) : _c('div', {
    staticClass: "row-filter-small"
  }, [_c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('administracao.perfilAcesso.labels.visibilidadeAcessaTodos'))
    }
  })]), _c('div', {
    staticClass: "row row-filter-small p-5 bg-gray"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('p', {
    staticClass: "mb-0"
  }, [_c('strong', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('administracao.perfilAcesso.etapas.contasBancarias'))
    }
  })])])]), (_vm.profile.bankAccountsSelected.length > 0) ? _c('div', {
    staticClass: "row"
  }, _vm._l((_vm.profile.bankAccountsSelected), function(bankAccount) {
    return _c('div', {
      staticClass: "col-xs-6 row-filter-small pl-0"
    }, [_c('p', {
      staticClass: "mb-0"
    }, [_vm._v(_vm._s(_vm.$t('contaBancaria.labels.nome')) + " (" + _vm._s(_vm.$t('contaBancaria.labels.banco')) + "): " + _vm._s(bankAccount.nome) + " (" + _vm._s(bankAccount.banco.nomeFantasia) + ")")]), _c('p', {
      staticClass: "mb-0"
    }, [_vm._v(_vm._s(_vm.$t('contaBancaria.labels.agencia')) + ": " + _vm._s(bankAccount.numAgencia) + _vm._s(bankAccount.digAgencia ? '-' + bankAccount.digAgencia : ''))]), _c('p', {
      staticClass: "mb-0"
    }, [_vm._v(_vm._s(_vm.$t('contaBancaria.labels.numeroConta')) + ": " + _vm._s(bankAccount.conta) + _vm._s(bankAccount.digConta ? '-' + bankAccount.digConta : ''))])])
  }), 0) : _c('div', {
    staticClass: "row-filter-small"
  }, [_c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('administracao.perfilAcesso.labels.visibilidadeAcessaTodos'))
    }
  })])])]), _c('div', {
    staticClass: "row row-filter-small"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('button-primary', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isMasterProfile(_vm.profileToEditId) || _vm.currentStep === 3),
      expression: "isMasterProfile(profileToEditId) || currentStep === 3"
    }],
    staticClass: "pull-right",
    attrs: {
      "type": "submit",
      "id": "btnSaveProfile",
      "label": _vm.$t('administracao.perfilAcesso.labels.salvar'),
      "disabled": _vm.isMasterProfile(_vm.profileToEditId) || _vm.requestSaveProfileSent
    }
  }), _c('button-primary', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isMasterProfile(_vm.profileToEditId) && _vm.currentStep !== 3),
      expression: "!isMasterProfile(profileToEditId) && currentStep !== 3"
    }],
    staticClass: "pull-right",
    attrs: {
      "id": "btnNextStep",
      "label": _vm.$t('administracao.perfilAcesso.labels.proximo'),
      "clickFunction": _vm.nextStep
    }
  }), _c('button-primary', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currentStep === 0),
      expression: "currentStep === 0"
    }],
    staticClass: "pull-right",
    attrs: {
      "id": "btnCancel",
      "customClass": "secondary",
      "label": _vm.$t('administracao.perfilAcesso.labels.cancelar'),
      "clickFunction": _vm.back
    }
  }), _c('button-primary', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isMasterProfile(_vm.profileToEditId) && _vm.currentStep !== 0),
      expression: "!isMasterProfile(profileToEditId) && currentStep !== 0"
    }],
    staticClass: "pull-right",
    attrs: {
      "id": "btnBackStep",
      "customClass": "secondary",
      "label": _vm.$t('administracao.perfilAcesso.labels.voltar'),
      "clickFunction": _vm.backStep
    }
  })], 1)])], 1)])], 1)])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-0643cdba", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0643cdba"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./client/components/views/administration/accessProfile/new.pug
// module id = 1359
// module chunks = 0